export default function CompletionScreen() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[calc(100vh-200px)] text-center">
      <div className="w-20 h-20 rounded-full bg-coral flex items-center justify-center mb-6">
        <i className="ri-check-line text-white text-3xl" />
      </div>

      <h2 className="text-xl font-bold text-text-primary mb-2">제출 완료!</h2>

      <p className="text-sm text-text-secondary leading-relaxed max-w-xs mb-5">
        맞춤 큐레이션을 준비했어요.<br />
        방문하시면 바로 상담이 시작됩니다.
      </p>

      <div className="inline-flex items-center gap-1.5 bg-coral-light text-coral-dark text-xs font-semibold px-4 py-2 rounded-full">
        <i className="ri-tablet-line text-sm" />
        <span>응답 결과가 매장 태블릿에 연동되었습니다</span>
      </div>
    </div>
  );
}